import { AfterViewInit, Component, ElementRef, NgZone, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, FormArray , NgForm, Validators } from "@angular/forms";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { AuthService } from "../../main/auth.service";
import { environment } from "../../../environments/environment";
import {
  ArkUserType,
  PermissionModel,
  PermissionViewModel,
  NavigationLinkViewModel,
  ClientViewModel,
  ClientAssignedPermissionViewModel
} from "../../core/api/models";
import { HttpClient, HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { map, tap } from "rxjs/operators";
import { Utils } from "../../core/utils";
import { AlertService } from "../../shared/services/alert.service";
import {
  PermissionsApiService,
  NavigationApiService,
  ClientsApiService,
  ClientUsersApiService,
  SystemSettingsApiService
} from "../../core/api/services";
import { Table } from "primeng/table";
import { DomSanitizer } from "@angular/platform-browser";

interface AutoCompleteCompleteEvent {
  originalEvent: Event;
  query: string;
}


@Component({
  selector: 'app-permissions-component',
  templateUrl: './permissions.component.html',
  standalone: false
})
export class PermissionsComponent implements OnInit, AfterViewInit {
  

  public pageTitle: string = 'Permissions';

  filter: any = {};
  list: any = undefined;
  loadingList: boolean = true;


  @ViewChild('itemForm') itemForm!: NgForm;

  @ViewChild('dt1') table?: Table;;
  
  itemFormGroup!: FormGroup;
  currentItem?: PermissionModel;

  get NavigationLinks() {
    return this.itemFormGroup.controls["NavigationLinks"] as FormArray;
  }

  loading: boolean = false;

  permissionTypes: any[] | undefined ;
  loadingPermissionTypes: boolean = false;
  permissionCategories: any[] | undefined ;
  loadingPermissionCategories: boolean = false;
  featureSwitches: any[] | undefined ;
  loadingFeatureSwitches: boolean = false;


  filteredNavigationLinks: any[] = [];
  navigationLinks: NavigationLinkViewModel[] | undefined;
  loadingNavigationLinks: boolean = false;

  ///////


  clientVisible: boolean = false;
  clientPersmissionItem?: PermissionViewModel ;
  
  clientID: number | null = null;
  clients: ClientViewModel[] | undefined;
  loadingClients: boolean = false;

  clientItem?: ClientViewModel;
  clientAssignedPermission?: ClientAssignedPermissionViewModel;



  clientAssignedPermissionFormGroup!: FormGroup;
  get ClientAssignedPermissionRoles() {
    return this.clientAssignedPermissionFormGroup.controls["ClientAssignedPermissionRoles"] as FormArray;
  }
  get ClientAssignedPermissionUsers() {
    return this.clientAssignedPermissionFormGroup.controls["ClientAssignedPermissionUsers"] as FormArray;
  }


  filteredClientRoles: any[] = [];
  loadingClientRoles: boolean = false;
  filteredClientUser: any[] = [];
  loadingClientUser: boolean = false;

  

  constructor(private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    private apiService: PermissionsApiService,
    private navigationApiService: NavigationApiService,
    private clientApiService: ClientsApiService,
    private clientUsersApi: ClientUsersApiService,
    private systemSettingsApiService: SystemSettingsApiService,
    private sanitizer: DomSanitizer,
    private formBuilder: FormBuilder) {
  }


  ngOnInit(): void {


    this.route.paramMap.subscribe((params: ParamMap) => {
      let ID = + ( params.get('ID') || '0');
      if (ID > 0) {
        console.info('Loading ' + ID);

      this.apiService.Get({ body: { id: ID } })
        .forEach(data => {
          this.loadingList = false;
          this.currentItem = data;
          this.load();
          
          this.route.queryParams.subscribe((queryParams) => {
            let clientID = + (queryParams['clientID'] || '0');
            console.info('clientID ' + clientID);
            if (clientID > 0) {
              this.onRowView(undefined);
              this.clientID = clientID;
              this.clientSelect();
            } else {
              this.clientVisible = false;
            }
          });

        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));

          });

      }
    });

    this.authService.checkIfAutorized([ArkUserType.Support, ArkUserType.Admin]);


    this.itemFormGroup = this.formBuilder.group(
      {

        //userId: [],
        DisplayName: ['', [Validators.required, Validators.maxLength(255)]],
        Description: ['', [Validators.maxLength(1000)]],
        OpenToBeAssigned: [false, []],
        NotForRoles: [false, []],
        NotForUsers: [false, []],
        PermissionType: [],
        SystemFeature: [],
        PermissionCategory: [],
        NavigationLinks: this.formBuilder.array([])
      });

    this.clientAssignedPermissionFormGroup = this.formBuilder.group(
      {
        ClientID: [],
        PermissionID: [],
        ClientAssignedPermissionRoles: this.formBuilder.array([]),
        ClientAssignedPermissionUsers: this.formBuilder.array([])
      });
  }

  ngAfterViewInit(): void {
    
    /*
    this.filter = {
      filters: {
        "Active": [
          {
            "value": "true",
            "matchMode": "contains",
            "operator": "and"
          }
        ]
      }
    }; 
    ;
    */
    
  }



  loadTable(event: any) {
    if (event || !this.filter) {
      this.filter = Utils.normalizePrimeDatatableEvent(event || this.filter || { filters: {} });
    }

    this.loadingList = true;
    this.apiService.List({ body: this.filter })
      .forEach(
        (result) => {
          this.list = result;
          this.loadingList = false;
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
            this.loadingList = false;
          });
  }


  clear(table: Table) {
    this.table = table;
    table.clear();
  }


  addItem(table: Table) {
    this.alertService.info('TO DO - Add new permission');
  }


  onRowEditInit(item: PermissionViewModel) {

    this.loadingList = true;


    this.apiService.Get({ body: { id: item.ID || 0 } })
      .forEach(data => {
        this.loadingList = false;
        this.currentItem = data;
        this.load()


      }).catch(
        (err) => {
          this.alertService.error(Utils.getAjaxError(err));
        });

  }


  load() {
    if (!this.currentItem)
      return;
    console.info(this.currentItem);
    if (this.itemForm)
      this.itemForm.resetForm();
    if (this.itemFormGroup)
      this.itemFormGroup.clearValidators();
              

    this.itemFormGroup.patchValue(this.currentItem);


    if (this.permissionTypes == undefined) {
      this.loadingPermissionTypes = true;
      this.apiService.GetPermissionTypes().forEach(data => {
        this.permissionTypes = data || null;
        this.loadingPermissionTypes = false;
      })
    }

    if (this.permissionCategories == undefined) {
      this.loadingPermissionCategories = true;
      this.apiService.GetPermissionCategories().forEach(data => {
        this.permissionCategories = data || null;
        this.loadingPermissionCategories = false;
      })
    }
    if (this.featureSwitches == undefined) {
      this.loadingFeatureSwitches = true;
      this.systemSettingsApiService.GetSystemFeatures().forEach(data => {
        this.featureSwitches = data || undefined;
        this.loadingFeatureSwitches = false;
      }).catch(error => {
        this.loadingFeatureSwitches = false;
        this.alertService.error(Utils.getAjaxError(error));
      });
    }
    if (this.navigationLinks == undefined) {
      this.loadingNavigationLinks = true;
      this.navigationApiService.ListNavigationLinks({
        body: {
          multiSortMeta: [
            {
              Field: "Inactive",
              Order: 1
            },
            {
              Field: "LinkName",
              Order: 1
            }
          ]
        }
      })
        .forEach(data => {
        this.navigationLinks = data.Result || undefined;
        this.loadingNavigationLinks = false;
        this.loadItems();
      })
    } else {
      this.loadItems();
    }

  }

  loadItems() {

    if (!this.currentItem)
      return;

    this.NavigationLinks.clear();
    var xItems = [] as any[];
    if (this.currentItem.NavigationLinkIDs)
      for (var p of this.currentItem.NavigationLinkIDs) {
        this.NavigationLinks.push(this.newSubItem());
        var lookup = this.navigationLinks?.find(x => x.ID == p);
        xItems.push({
          Item: {
            ID: p,
            LinkName: lookup?.LinkName || 'Link ' + p,
            URL: lookup?.URL || null,
            Inactive: lookup?.Inactive || null
          }
        });
      }
    this.itemFormGroup.patchValue({
      NavigationLinks: xItems
    });


  }

  newSubItem() {
    return this.formBuilder.group({
      Item: [],
    });
  }

  addSubItem() {
    this.NavigationLinks.push(this.newSubItem());
  }
  deleteSubItem(taskIndex: number) {
    this.NavigationLinks.removeAt(taskIndex);
  }
  cancel() {
    this.currentItem = undefined;
    if (this.itemForm)
      this.itemForm.resetForm();
  }

  save() {

    if (!this.itemFormGroup.valid) {

      const errors = Utils.getFormErrors(this.itemFormGroup);

      if (errors.length > 0) {
        this.alertService.error(errors.join(' \n'));
        return;
      }
    }
    var formValue = this.itemFormGroup.getRawValue();

    formValue.NavigationLinkIDs = [];
    for (var item of formValue.NavigationLinks) {
      if (!item.Item || !item.Item.ID)
        continue;
      formValue.NavigationLinkIDs.push(item.Item.ID);
    }
    delete formValue.NavigationLinks;

    let newItem =
    {
      ...this.currentItem,
      ...formValue
    }
    console.info(newItem);


    this.loading = true;
    this.apiService.Save({ body: newItem })
      .forEach(
        (savedItem) => {

          this.loading = false;
          this.currentItem = undefined;
          if (this.itemForm)
            this.itemForm.resetForm();
          this.alertService.success('Item saved successfully');
          this.loadTable(null);

        }).catch (
          err => {
            this.loading = false;
            this.alertService.error(Utils.getAjaxError(err));
          
        });


  }



  filterNavigationLink(event: AutoCompleteCompleteEvent) {
    let filtered: any[] = [];
    let query = event.query;
    if (query.indexOf('[')>0)
      query = query.substring(0, query.indexOf('[')).trim();

    for (let i = 0; i < (this.navigationLinks as any[]).length; i++) {
      let item = (this.navigationLinks as NavigationLinkViewModel[])[i];
      if ((item.LinkName && item.LinkName.toLowerCase().indexOf(query.toLowerCase()) >= 0)
        || (item.URL && item.URL.toLowerCase().indexOf(query.toLowerCase()) >= 0)) {
        filtered.push(item);
      }
    }

    this.filteredNavigationLinks = filtered;
  }
  labelNavigationLink(item: any) {
    if (item.Inactive)
      return `${item.LinkName} [${item.URL}] [INACTIVE]`;
    return `${item.LinkName} [${item.URL}]`;
  }


  ////////


  onRowView(item: PermissionViewModel | undefined) {

    if (item)
      this.clientPersmissionItem = item;
    else if (this.currentItem)
      this.clientPersmissionItem = {
        ...this.currentItem,
        Permission: this.currentItem.DisplayName,
      } as PermissionViewModel;
    else
      return;
    
    this.clientID = null;
    this.clientAssignedPermission = undefined;
    this.clientItem = undefined;
    this.clientVisible = true;


    if (this.clients == undefined) {
      this.loadingClients = true;
      this.clientApiService.List({
        body: {
          multiSortMeta: [
            {
              Field: "Active",
              Order: -1
            },
            {
              Field: "SiteName",
              Order: 1
            }
          ]
        }
      })
        .forEach(data => {
          this.clients = data.Result || undefined;
          if (this.clientID && this.clientID>0)
            this.clientItem = this.clients?.find(x => x.ID == this.clientID) || undefined;
        this.loadingClients = false;
      })
    } 

  }


  clientSelect() {

    this.clientItem = this.clients?.find(x => x.ID == this.clientID) || undefined;
    if (!this.clientItem && this.clients) {
      this.alertService.error('Please select a client');
      return;
    }
    this.loading = true;
    this.apiService.GetClientAssignedPermission({
      body: {
        clientID: this.clientID || 0,
        permissionID: this.clientPersmissionItem?.ID || 0
      }
    }).forEach((r) => {
      this.loading = false;
      console.info(r);
      this.clientAssignedPermission = r;

      
      this.clientAssignedPermissionFormGroup.clearValidators();

      this.ClientAssignedPermissionRoles.clear();
      this.ClientAssignedPermissionUsers.clear();
      var xRoles = [] as any[];
      var xUsers = [] as any[];

      if (this.clientAssignedPermission.Roles)
        for (var x of this.clientAssignedPermission.Roles) {
          this.ClientAssignedPermissionRoles.push(this.newAssignedPermissionRole());
          xRoles.push({
            Item: x
          });
        }
      if (this.clientAssignedPermission.Users)
        for (var y of this.clientAssignedPermission.Users) {
          this.ClientAssignedPermissionUsers.push(this.newAssignedPermissionUser());
          xUsers.push({
            Item: y
          });
        }

      this.clientAssignedPermissionFormGroup.patchValue({
        ClientAssignedPermissionRoles: xRoles,
        ClientAssignedPermissionUsers: xUsers
      });

      
    }).catch(
      err => {
        this.alertService.error(Utils.getAjaxError(err));
        this.loading = false;
      }).
      finally(() => {
      });


  }
  clientSavePermission() {

    var userIDs: number[] = [];
    var userTypeIDs: number[] = [];

    var formValue = this.clientAssignedPermissionFormGroup.getRawValue();

    
    for (var item of formValue.ClientAssignedPermissionRoles) {
      if (!item.Item || !item.Item.RoleID)
        continue;
      userTypeIDs.push(item.Item.RoleID);
    }
    for (var item of formValue.ClientAssignedPermissionUsers) {
      if (!item.Item || !item.Item.ID)
        continue;
      userIDs.push(item.Item.ID);
    }

    let newItem = {
      clientID: this.clientID || 0,
      permissionID: this.clientPersmissionItem?.ID || 0,
      userIDs: userIDs,
      userTypeIDs: userTypeIDs
    }
    console.info(newItem);

    this.loading = true;
    this.apiService.SaveClientAssignedPermission({
      body: newItem
    }).forEach((r) => {
      this.loading = false;

      this.clientVisible = false;
      this.clientAssignedPermission = undefined;
      if (this.itemForm)
        this.itemForm.resetForm();
      this.alertService.success('Item saved successfully');

    }).catch(
      err => {
        this.alertService.error(Utils.getAjaxError(err));
        this.loading = false;
      }).
      finally(() => {
      });


  }



  newAssignedPermissionRole() {
    return this.formBuilder.group({
      Item: [],
    });
  }

  addAssignedPermissionRole() {
    this.ClientAssignedPermissionRoles.push(this.newAssignedPermissionRole());
  }
  deleteAssignedPermissionRole(taskIndex: number) {
    this.ClientAssignedPermissionRoles.removeAt(taskIndex);
  }
  filterClientAssignedPermissionRoles(event: AutoCompleteCompleteEvent) {
    let filtered: any[] = [];
    let query = event.query;
    if (query.indexOf('[') > 0)
      query = query.substring(0, query.indexOf('[')).trim();


    this.loadingClientRoles = true;
    //this.filteredClientRoles =[] ;
    this.clientUsersApi.SearchRoles({
      clientID: this.clientID || 0,
      body: {
        prefixText: query,
        count: 25
      }
    })
      .forEach((result) => {
        this.loadingClientRoles = false;
        this.filteredClientRoles = result;
      }).catch(
        err => {
          this.loadingClientRoles = false;
          this.alertService.error(Utils.getAjaxError(err));
        });


  }
  labelClientAssignedPermissionRoles(item: any) {
    if (item.Hidden)
      return `${item.Role} [Hidden]`;
    return item.Role;
  }



  newAssignedPermissionUser() {
    return this.formBuilder.group({
      Item: [],
    });
  }

  addAssignedPermissionUser() {
    this.ClientAssignedPermissionUsers.push(this.newAssignedPermissionUser());
  }
  deleteAssignedPermissionUser(taskIndex: number) {
    this.ClientAssignedPermissionUsers.removeAt(taskIndex);
  }
  filterClientAssignedPermissionUsers(event: AutoCompleteCompleteEvent) {
    let filtered: any[] = [];
    let query = event.query;
    if (query.indexOf('[') > 0)
      query = query.substring(0, query.indexOf('[')).trim();
    if (query.indexOf(' - ') > 0)
      query = query.substring(0, query.indexOf(' - ')).trim();
    
    this.loadingClientUser = true;
    //this.filteredClientUser =[] ;
    this.clientUsersApi.Search({
      clientID: this.clientID || 0,
      body: {
        prefixText: query,
        count: 25
      }
    })
      .forEach((result) => {
        this.loadingClientUser = false;
        this.filteredClientUser = result;
      }).catch(
        err => {
          this.loadingClientUser = false;
          this.alertService.error(Utils.getAjaxError(err));
        });
   
  }
  labelClientAssignedPermissionUser(item: any) {
    let name = `${item.UserName} - ${item.FirstName} ${item.LastName}`;
    if (item.Inactive)
      return `${name} [INACTIVE]`;
    if (item.Hidden)
      return `${name} [Hidden]`;
    return name;
  }
}
